import LANG from './en'

/** breakpoint where help switches from footer to header */
export const HELP_BREAKPOINT = 1280

export const FOOTER = {
  branding: {
    url: '#',
    alt: 'Stanford',
    imgSrc: 'https://placehold.it/200x40'
  },
  links: [
    {
      id: 'export',
      label: 'Export',
      items: [
        {
          id: 'facebook',
          label: LANG['FOOTER_SHARE_FACEBOOK']
        },
        {
          id: 'twitter',
          label: LANG['FOOTER_SHARE_TWITTER']
        },
        {
          id: 'link',
          label: LANG['FOOTER_SHARE_LINK']
        }
      ]
    },
    {
      id: 'share',
      label: 'Share',
      items: [
        {
          id: 'pdf',
          label: LANG['FOOTER_EXPORT_PDF']
        },
        {
          id: 'ppt',
          label: LANG['FOOTER_EXPORT_PPT']
        }
      ]
    }
  ],
  copyright: LANG['FOOTER_COPYRIGHT']
}

export const MENU = {
  navItems: [
    {
      id: 'home',
      url: '/',
      label: LANG['MENU_HOME']
    },
    {
      id: 'opportunity',
      url: '/opportunity',
      label: LANG['MENU_OPPORTUNITY'],
      sublabel: LANG['MENU_OPPORTUNITY_SUB']
    },
    {
      id: 'trends',
      url: '/trends',
      label: LANG['MENU_TRENDS'],
      sublabel: LANG['MENU_TRENDS_SUB']
    },
    {
      id: 'early-childhood',
      url: '/early-childhood',
      label: LANG['MENU_EARLY_CHILDHOOD'],
      sublabel: LANG['MENU_EARLY_CHILDHOOD_SUB']
    },
    {
      id: 'segregation',
      url: '/segregation',
      label: LANG['MENU_SEGREGATION']
    },
    {
      id: 'discoveries',
      url: '/discoveries',
      label: LANG['MENU_DISCOVERIES']
    },
    {
      id: 'research',
      url: '/research',
      label: LANG['MENU_RESEARCH']
    },
    {
      id: 'news',
      url: '/news',
      label: LANG['MENU_NEWS']
    }
  ],
  verticalNavItems: [
    {
      id: 'explorer',
      url: '/explorer',
      label: LANG['MENU_VERTICAL_EXPLORER'],
    },
    {
      id: 'about',
      url: '/about',
      label: LANG['MENU_VERTICAL_ABOUT'],
    },
    {
      id: 'methods',
      url: '/methods',
      label: LANG['MENU_VERTICAL_METHODS'],
    },
    {
      id: 'faq',
      url: '/faq',
      label: LANG['MENU_VERTICAL_FAQ'],
    },
    {
      id: 'data',
      url: '/data',
      label: LANG['MENU_VERTICAL_DATA'],
    },
  ],
  socialItems: [
    {
      id: 'facebook',
      url: 'https://www.facebook.com/edopportunity/',
      label: LANG['MENU_FACEBOOK'],
      icon: 'facebook'
    },
    {
      id: 'twitter',
      url: 'https://twitter.com/seda_data',
      label: LANG['MENU_TWITTER'],
      icon: 'twitter'
    }
  ]
}
